import type { ReactElement } from 'react';

import { useCurrencyFormatterConnected } from '../../../../hooks/useCurrencyFormatterConnected';
import { useTotalBetWalletPlaceholder } from '../hooks/useTotalBetWalletPlaceholder';
import { StickyWidthValue } from '../stickyWidthValue/StickyWidthValue';

export const LastWinValueConnected = ({ value }: { value: number }): ReactElement => {
  const totalBetWidthPlaceholder = useTotalBetWalletPlaceholder() || '';
  const currencyFormatter = useCurrencyFormatterConnected();
  const formattedValue = currencyFormatter(value) || '';

  const placeholder =
    totalBetWidthPlaceholder.length > formattedValue?.length ? totalBetWidthPlaceholder : formattedValue;

  return <StickyWidthValue placeholder={placeholder}>{currencyFormatter(value)}</StickyWidthValue>;
};
